export function NextStepHeading({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex">
      <p className="rounded bg-muted px-3 py-0.5 text-base font-light text-muted-foreground">
        Next step: <span className="font-semibold text-foreground">{children}</span>
      </p>
    </div>
  )
}
